<template lang="pug">
div(v-if="dadosJson")
  el-tabs.tabs(
    @tab-click="handleClick",
    v-model="abaAtiva",
  )
    el-tab-pane.tab(name='Informações Gerais')
      span(slot="label")
        | Informações Gerais &nbsp
      informacoes-gerais-rf(
        :dadosJson="dadosJson",
      )
    el-tab-pane.tab(name='Outorgante')
      span(slot="label")
        | Outorgante &nbsp
      outorgante-rf(
        :dadosJson="dadosJson",
      )
    el-tab-pane.tab(name='Imóvel')
      span(slot="label")
        | Imóvel &nbsp
      imovel-rf(
        v-if="abaAtiva === 'Imóvel'"
        :dadosJson="dadosJson",
      )
    el-tab-pane.tab(name='Avaliação Imóvel')
      span(slot="label")
        | Avaliação Imóvel &nbsp
      avaliacao-rf(
        :dadosJson="dadosJson",
      )
</template>

<script>

import AppDisplay from '@/components/AppDisplay'
import AppButton from '@/components/AppButton'
import AppResumoGeo from '@/components/resumo/AppResumoGeo'

import ListagemDocumentos from '@/components/informacoesCadastro/ListagemDocumentos'

import InformacoesCadastrante from '@/components/informacoesCadastro/cadastrosOnline/InformacoesCadastrante'
import InformacoesInteressado from '@/components/informacoesCadastro/cadastrosOnline/InformacoesInteressado'
import InformacoesImovel from '@/components/informacoesCadastro/cadastrosOnline/InformacoesImovel'
import InformacoesTermoCompromisso from '@/components/informacoesCadastro/InformacoesTermoCompromisso'
import InformacaoDesejada from '@/components/informacoesCadastro/cadastrosOnline/solicitacaoInformacao/InformacaoDesejada'
import InformacoesImovelSolicitacao from '@/components/informacoesCadastro/cadastrosOnline/solicitacaoInformacao/InformacoesImovelSolicitacao'
import InformacoesAforamentoImovel from '@/components/informacoesCadastro/cadastrosOnline/informacoesAforamento/InformacoesAforamentoImovel'
import InformacoesReurbColetivoImovel from '@/components/informacoesCadastro/cadastrosOnline/informacoesReurbColetivo/InformacoesReurbColetivoImovel'
import InformacoesQualificacaoPermuta from '@/components/informacoesCadastro/cadastrosOnline/informacoesPermuta/InformacoesQualificacaoPermuta'
import InformacoesImovelPermuta from '@/components/informacoesCadastro/cadastrosOnline/informacoesPermuta/InformacoesImovelPermuta'
import InformacoesImovelTransferencia from '@/components/informacoesCadastro/cadastrosOnline/transferenciaDireitos/InformacoesImovelTransferencia'
import InformacoesImovelCancelamento from '@/components/informacoesCadastro/cadastrosOnline/cancelamentoClausula/InformacoesImovelCancelamento'
import InformacoesCadastranteAreasPatrimoniais from '@/components/informacoesCadastro/cadastrosOnline/areasPatrimoniais/InformacoesCadastranteAreasPatrimoniais'
import InformacoesInteressadoAreasPatrimoniais from '@/components/informacoesCadastro/cadastrosOnline/areasPatrimoniais/InformacoesInteressadoAreasPatrimoniais'
import InformacoesAdministrativasUc from '../InformacoesAdministrativasUc.vue'
import AtosLegaisUc from '../AtosLegaisUc.vue'
import ContatoUc from '../ContatoUc.vue'
import LocalizacaoUc from '../LocalizacaoUc.vue'
import OutorganteRf from '../OutorganteRf.vue'
import ImovelRf from '../ImovelRf.vue'
import AvaliacaoRf from '../AvaliacaoRf.vue'
import GeorreferenciamentoRf from '../GeorreferenciamentoRf.vue'
import InformacoesGeraisRf from '../InformacoesGeraisRf.vue'

export default {

  components: {
    ImovelRf,
    AvaliacaoRf,
    GeorreferenciamentoRf,
    InformacoesGeraisRf,
    AppDisplay,
    AppButton,
    InformacoesCadastrante,
    InformacoesAdministrativasUc,
    AtosLegaisUc,
    OutorganteRf,
    ContatoUc,
    LocalizacaoUc,
    InformacoesInteressado,
    InformacoesImovel,
    AppResumoGeo,
    ListagemDocumentos,
    InformacaoDesejada,
    InformacoesImovelSolicitacao,
    InformacoesAforamentoImovel,
    InformacoesQualificacaoPermuta,
    InformacoesReurbColetivoImovel,
    InformacoesImovelPermuta,
    InformacoesImovelTransferencia,
    InformacoesCadastranteAreasPatrimoniais,
    InformacoesInteressadoAreasPatrimoniais,
    InformacoesTermoCompromisso,
    InformacoesImovelCancelamento
  },

  props: {
    dadosJson: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      abaAtiva: 'Informações Gerais',
      processo: null
    }
  },
  methods: {
    handleClick (tab) {
      this.abaAtiva = tab.name
    }
  }
}
</script>
<style lang="scss" scoped>
  span {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/CadastroRf.vue